import { Icon, Button, Pill } from '@iwoca/orion';

import InputTooltip from '../../InputTooltip/InputToolTip';
import OfferCard from '../OfferCard';

const RBLOfferCard = ({
    amount,
    onSelect,
    isPartnerCustomer,
    offerType,
    sweep
}: {
    amount: string;
    onSelect: () => void;
    isPartnerCustomer: boolean;
    offerType: string;
    sweep: { min: string; max: string };
}) => {
    return (
        <OfferCard
            pills={
                <>
                    <Pill variant="london">Eligible</Pill>
                </>
            }
            title={
                isPartnerCustomer ? (
                    <h3>Revenue based loan</h3>
                ) : (
                    <h3>Repay based on on your monthly sales</h3>
                )
            }
            features={
                <ul>
                    <li>
                        <Icon icon="clockOutline" /> Decision in 24 hours
                    </li>
                    <li>
                        <Icon icon="calendarOutline" /> Borrow from 1 day to 12
                        months
                    </li>
                    <li>
                        <Icon icon="link" /> Link your bank account
                    </li>
                </ul>
            }
            details={
                <ul>
                    {offerType === 'confirmed' ? (
                        <li>
                            Confirmed amount <span>{amount}</span>
                        </li>
                    ) : (
                        <li>
                            Estimated amount <span>{amount}</span>
                        </li>
                    )}

                    <li>
                        <p>
                            Monthly repayment
                            <InputTooltip
                                overlayText="Your monthly repayments will be a percentage of your sales"
                                overlayPlacement="top"
                            />
                        </p>{' '}
                        <span>
                            {sweep && sweep.min}-{sweep && sweep.max}% of
                            revenue
                        </span>
                    </li>
                </ul>
            }
            button={
                <Button variant="secondary" onClick={onSelect}>
                    Link bank account
                </Button>
            }
            footer={
                <p>
                    Once you've provided the key documents, we'll give you our
                    decision within 1 business day. This won't affect your
                    credit score. The loan amount might change depending on what
                    you tell us - and we can't guarantee you'll be approved.
                </p>
            }
        />
    );
};

export default RBLOfferCard;
